import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Spin } from 'antd';
import { makeRequest } from '@utils/helpers';
import { getNoticPeriodEmployeeReq } from '../requests';
import "../dashboard.css"
import { Icon } from '@iconify/react';
import useInViewport from '../useInViewport';

const NoticePeriodEmployees = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const viewRef = useRef(null);
  const viewport = useInViewport(viewRef);
  useEffect(() => {
    if (viewport && data.length === 0) {
      makeRequest(setLoader, getNoticPeriodEmployeeReq, null, onSuccess, Function)
    }
  }, [viewport]);

  const onSuccess = (data) => {
    setData(data);
  }

  return (
    <div className='widgetbox' ref={ viewRef } style={ {
      backgroundColor: '#f55d51',
      paddingBottom: '0px',
    } }>
      <Spin spinning={ loader } tip="Loading...">
        <Row style={ {
          color: '#fff',
        } }>
          <Col span={ 7 } style={ {
            textAlign: 'left',
            paddingLeft: '20px',
            paddingTop: '20px',
          } }>
            <Icon style={ {
              fontSize: '50px',
            } } icon="ph:clock-bold" />
          </Col>
          <Col span={ 17 } style={ {
            textAlign: 'right',
            paddingTop: '10px',
            paddingRight: '20px',
          } }>
            <h2 style={ {
              color: '#fff',
            } }>{ data.employee_notice_period }</h2>
            <h6 style={ {
              color: '#fff',
              marginTop: '30px',
              borderBottom: '1px solid #fff',
              paddingBottom: '20px',
              fontSize: '14px',
            } }>Employees Serving Notice Period</h6>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default NoticePeriodEmployees;